import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  padding: 8px 12px;
  width: 100%;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleLabel = styled.span`
  ${typographyV2.bodySm};
`;

export const PdfIcon = styled.img`
  height: 21px;
  width: 18px;
`;

export const StyledSkeletonLoaderWrapper = styled.div`
  width: 100%;
  height: 52px;
`;

export const styledSkeletonLoaderAreas = [
  {
    styles: {
      width: '100%',
      height: '100%',
      borderRadius: '8px',
    },
  },
];

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
